<setup-node [allowEdit]="true" [editing]="editing()" [displayTemplate]="displayTemplate" [editTemplate]="editTemplate">
  <ng-template #displayTemplate>
    <span class="milestone-name">{{ milestone().name }}</span>
    <span class="milestone-weighting" *ngIf="milestone().weight">({{ milestone().weight }})</span>
  </ng-template>
  <ng-template #editTemplate>
    <div class="edit-container">
      <dx-form class="gpd-form" [formData]="milestone()" [colCount]="5" width="100%" [showColonAfterLabel]="false">
        <dxi-form-item dataField="name" caption="Name" i18n-text="@@name" [colSpan]="3" cssClass="gpd-input">
          <dx-text-box
            class="gpd-input"
            [(value)]="milestone().name"
            (onValueChanged)="onDataChanged()"
            valueChangeEvent="input"
            validationMessageMode="always"
            [maxLength]="50"
          >
            <dx-validator>
              <dxi-validation-rule type="required" i18n-message="@@required" message="Required" />
              <dxi-validation-rule
                type="custom"
                [reevaluate]="true"
                [validationCallback]="uniqueNameValidationCallback"
                i18n-message="@@nameAlreadyExists"
                message="Name already Exists."
              />
            </dx-validator>
          </dx-text-box>
        </dxi-form-item>
        <dxi-form-item
          dataField="weighting"
          caption="Weighting"
          i18n-text="@@weighting"
          [isRequired]="true"
          [colSpan]="2"
        >
          <div class="weighting-form-item">
            <!-- <app-svg-icon
              icon="help"
              color="var(--color-grey-900)"
              class="help-icon-1"
              [size]="16"
            >
            </app-svg-icon>
            <dx-popover
              target=".help-icon-1"
              showEvent="mouseenter"
              hideEvent="mouseleave"
              [wrapperAttr]="{ class: 'gpd-popover' }"
              position="bottom"
              style="display: none"
            >
              <div class="help-context" i18n="@@milestoneHelp">
                Milestones represent key deliverables or checkpoints within a
                phase. The weighting determines the relative importance of this
                milestone within its phase.
              </div>
            </dx-popover> -->
            <dx-number-box
              class="gpd-input"
              [(value)]="milestone().weight"
              (onValueChanged)="onDataChanged()"
              valueChangeEvent="input"
              validationMessageMode="always"
              [min]="0"
              [max]="100"
              [showSpinButtons]="false"
            >
              <dx-validator>
                <dxi-validation-rule type="required" i18n-message="@@required" message="Required" />
                <dxi-validation-rule
                  type="range"
                  [min]="0"
                  [max]="100"
                  i18n-message="@@milestoneConfigWeightingInvalidRange"
                  message="Weighting must be between 0 and 100"
                />
              </dx-validator>
            </dx-number-box>
          </div>
        </dxi-form-item>
      </dx-form>
      <div class="gpd-button-group">
        <app-svg-icon
          *ngIf="allowDelete()"
          icon="delete"
          [size]="24"
          color="var(--color-red-500)"
          class="gpd-button-icon"
          (click)="onDeleteClicked()"
        ></app-svg-icon>
      </div>
    </div>
    <dx-validator [adapter]="adapterConfig">
      <dxi-validation-rule
        type="custom"
        [validationCallback]="validationCallback"
        i18n-message="@@milestoneConfigInvalidValidationMessage"
        message="Milestone configuration is invalid"
        style="display: none"
      ></dxi-validation-rule>
    </dx-validator>
  </ng-template>
</setup-node>
